import { get } from "@/api";

export interface CategoryNode {
  id: number | string;
  title: string;
  pid?: number | string;
  enterprise_id?: number | string;
  self_specs_count?: number;
  specs_count?: number;
  children?: CategoryNode[];
  [key: string]: unknown;
}

export interface CategoryTreeResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: CategoryNode[];
}

/** 获取商品分类树 */
export function getCategoryTree() {
  return get<CategoryTreeResponse>("/platform/category/tree");
}
